import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Login from './components/Login';
import TrackUtil from './components/utils/TrackUtil';
import Home from './components/home/Home';
import AppAlerts from './App.alerts';
import AppMatching from './App.matching';
import AuthProvider from './components/utils/AuthProvider';
import { ApiProvider, useApi } from './ApiContext';
import Spinner from './components/utils/Spinner';
import Logout from './components/Logout';
import ExportAlert from './components/export/ExportAlert';
import AppRouting from './App.routing';
import AppEmailNotices from './App.emailNotices';
import AppClientDataInfo from './App.clientDataInfo';
import ProtectedRoute from './components/utils/ProtectedRoute'; // import your ProtectedRoute

/**
 * AppWithSpinner wraps the app with API loading spinner
 */
const AppWithSpinner = () => {
  const { isApiLoading } = useApi();

  return (
    <>
      <Spinner isLoading={isApiLoading} />

      {/* HashRouter ensures SPA works with refresh and subpaths */}
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public route */}
            <Route path="/login" element={<Login />} />

            {/* Protected routes */}
            <Route
              path="/home"
              element={
                <ProtectedRoute allowed={['SUPER', 'ADMIN', 'USER']}>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/alerts/*"
              element={
                <ProtectedRoute allowed={['SUPER', 'ADMIN','USER']}>
                  <AppAlerts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/matching/*"
              element={
                <ProtectedRoute allowed={['SUPER', 'ADMIN', 'USER']}>
                  <AppMatching />
                </ProtectedRoute>
              }
            />
            <Route
              path="/export/*"
              element={
                <ProtectedRoute allowed={['SUPER', 'ADMIN','USER']}>
                  <ExportAlert />
                </ProtectedRoute>
              }
            />
            <Route
              path="/routing/*"
              element={
                <ProtectedRoute allowed={['SUPER', 'ADMIN']}>
                  <AppRouting />
                </ProtectedRoute>
              }
            />
            <Route
              path="/emails/*"
              element={
                <ProtectedRoute allowed={['SUPER', 'ADMIN','USER']}>
                  <AppEmailNotices />
                </ProtectedRoute>
              }
            />
            <Route
              path="/datainfo/*"
              element={
                <ProtectedRoute allowed={['SUPER', 'ADMIN']}>
                  <AppClientDataInfo />
                </ProtectedRoute>
              }
            />
            <Route
              path="/trackutil"
              element={
                <ProtectedRoute allowed={['SUPER', 'ADMIN']}>
                  <TrackUtil />
                </ProtectedRoute>
              }
            />
            <Route
              path="/logout"
              element={
                <ProtectedRoute allowed={['SUPER', 'ADMIN', 'USER']}>
                  <Logout />
                </ProtectedRoute>
              }
            />

            {/* default route redirects to login */}
            <Route path="/" element={<Login />} />
          </Routes>
        </AuthProvider>
      </Router>
    </>
  );
};

/**
 * Root App component
 */
const App = () => {
  return (
    <ApiProvider>
      <AppWithSpinner />
    </ApiProvider>
  );
};

export default App;
